import { render } from "./TheDms.vue?vue&type=template&id=05fd295c&scoped=true&lang=true"
import script from "./TheDms.vue?vue&type=script&lang=js"
export * from "./TheDms.vue?vue&type=script&lang=js"

import "./TheDms.vue?vue&type=style&index=0&id=05fd295c&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fd295c"]])

export default __exports__